import { unique } from "@foretagsplatsen/core-helpers/array";
import makeAccountStatementPopover from "../../visitors/viewer/makeAccountStatementPopover.js";
import RowTitleRenderer from "../../RowTitleRenderer/RowTitleRenderer.js";

/**
 * Render {@link Report} rows for the {@link ReportViewerWidget}. The
 * difference with the superclass is that account numbers of account
 * rows are rendered as links. A click on such a link opens a popover
 * allowing the user to go to the account statement page.
 *
 * @param {function} onAccountStatementRedirectionRequest - Will be
 *   called with an account number and a period and should open the
 *   account statement for this account number at this period
 */
export default class ReportViewerRowTitleRenderer extends RowTitleRenderer {
	constructor({ onAccountStatementRedirectionRequest }) {
		super(...arguments);

		this._onAccountStatementRedirectionRequest =
			onAccountStatementRedirectionRequest;
	}

	_accountNumberRenderer({ accountRow }) {
		const periods = this._periodsFromColumns();

		if (periods.length > 0) {
			return this._accountLinkRenderer({ accountRow, periods });
		}

		return super._accountNumberRenderer(...arguments);
	}

	_accountLinkRenderer({ accountRow, periods }) {
		return (html) => {
			let trigger;

			html.span({ klass: "account-number" }, (html) => {
				trigger = html.a(accountRow.getAccountNumber());
			});

			makeAccountStatementPopover({
				trigger,
				accountNumber: accountRow.getAccountNumber(),
				periods,
				onAccountStatementRedirectionRequest:
					this._onAccountStatementRedirectionRequest,
			});
		};
	}

	_periodsFromColumns() {
		return unique(
			this._report
				.getColumns()
				.filter((column) => column.isPeriodColumn())
				.map((column) => column.getPeriod()),
		);
	}
}
